import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { device } from '../breakpoints'

const FaceModule: FC = (): ReactElement => {
  return (
    <>
      <Container>
        <FaceIllustrationContainer>
          <Label topPct='8.85' leftPct='68.75'>
            1
          </Label>

          <Label topPct='34.8' leftPct='51.7'>
            2
          </Label>
          <Label topPct='32.75' leftPct='69'>
            3
          </Label>

          <Label topPct='40.15' leftPct='46.25'>
            4
          </Label>

          <Label topPct='47' leftPct='63.45'>
            5
          </Label>

          <Label topPct='49.05' leftPct='51.35'>
            6
          </Label>

          <Label topPct='56.1' leftPct='60.05'>
            7
          </Label>
          <FaceIllustrationNotes src={require('./numbers.png')} alt='face' />
          <FaceIllustration src={require('./face-b.png')} alt='face' />
        </FaceIllustrationContainer>
        <Legend>
          <Column>
            <LegendItem>
              <Number>1</Number>Microcéphalie
            </LegendItem>
            <LegendItem>
              <Number>2</Number>Racine du nez large
            </LegendItem>
            <LegendItem>
              <Number>3</Number>Espace séparant les paupières supérieure et
              inférieure très fin
            </LegendItem>
            <LegendItem>
              <Number>4</Number>Pli cutané allant de la paupière supérieure
              jusqu’au bord du nez
            </LegendItem>
          </Column>
          <Column>
            <LegendItem>
              <Number>5</Number>Narines antéversées
            </LegendItem>
            <LegendItem>
              <Number>6</Number>Philtrum long et bombé
            </LegendItem>
            <LegendItem>
              <Number>7</Number>Lèvre supérieure fine vermillon
            </LegendItem>
          </Column>
        </Legend>
      </Container>
      <TextWidth>
        <figcaption>
          <FaceLegend>
            Caractéristiques faciales des enfants Dépakine
          </FaceLegend>
          <Credits>
            Source: Association Suisse du Syndrome de l’Anti-Convulsivant
          </Credits>
        </figcaption>
      </TextWidth>
    </>
  )
}

const FaceLegend = styled.div`
  font-family: var(--font-sans-serif);
  -webkit-font-smoothing: auto;
  font-size: 1.5rem;
  line-height: 2.1rem;
  padding-top: 1.5rem;
`

const Credits = styled.div`
  font-family: var(--font-sans-serif);
  -webkit-font-smoothing: auto;
  font-size: 1.2rem;
  line-height: 1.8rem;
  color: #7d7d7d;
  padding-top: 0.3rem;
  text-transform: uppercase;
`

const Label = styled.div<{ topPct: string; leftPct: string }>`
  font-family: var(--font-sans-serif);
  position: absolute;
  top: ${({ topPct }) => topPct}%;
  left: ${({ leftPct }) => leftPct}%;
  z-index: 1;
  font-size: 0.75em;
  line-height: 1.2;
  max-width: 160px;
  color: #202020;
  z-index: 3;
  line-height: 0;
  font-weight: 700;
`

const Container = styled.div`
  background-color: #222233;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  min-height: 100vh;
  color: white;
  padding: 60px 0;
`

const FaceIllustrationContainer = styled.div`
  width: auto;
  height: auto;
  position: relative;
`

const FaceIllustrationNotes = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 600px;
  height: auto;
  z-index: 2;
`

const FaceIllustration = styled.img`
  width: 100%;
  max-width: 600px;
  height: auto;
  mix-blend-mode: luminosity;
`

const Legend = styled.div`
  display: flex;
  line-height: 1.2;
  margin-top: 40px;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
  }

  @media ${device.tablet}, @media ${device.laptop} {
  }
`

const Column = styled.div`
  flex: 50%;
  padding: 0 10px;
`

const LegendItem = styled.div`
  display: block;
  padding-left: 1.65em;
  position: relative;
  margin-bottom: 0.75em;
`

const Number = styled.div`
  top: 50%;
  left: 0;
  margin-top: -0.75em;
  position: absolute;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  background-color: #ffe462;
  font-weight: 700;
  font-size: 0.75em;
  border-radius: 50px;
  width: 1.5em;
  height: 1.5em;
  color: black;
`

export default FaceModule
